const actions = {
    GET_DOCUMENTS: 'clientDocuments/GET_DOCUMENTS',
    SET_DOCUMENTS: 'clientDocuments/SET_DOCUMENTS',

    GET_DOCUMENT: 'clientDocuments/GET_DOCUMENT',
    SET_DOCUMENT: 'clientDocuments/SET_DOCUMENT',

    SET_INITIAL_DOCUMENTS: 'clientDocuments/SET_INITIAL_DOCUMENTS'
};

export default actions